export const SKILLS_ROUTES = {
  OVERVIEW: {
    NAME: "skills",
    PATH: "/skills/overview"
  },
  VOCABULARY_PRACTICE: {
    NAME: "vocabulary_practice",
    PATH: "/skills/practice/vocabulary"
  },
  PRONUNCIATION_PRACTICE: {
    NAME: "pronunciation_practice",
    PATH: "/skills/practice/pronunciation"
  },
  LISTENING_PRACTICE: {
    NAME: "listening_practice",
    PATH: "/skills/practice/listening"
  }
};
